import { CalendarCell as AriaCalendarCell } from "react-aria-components";
import type { CalendarCellProps as AriaCalendarCellProps } from "react-aria-components";
import type { ReactNode } from "react";

import { cn } from "@/lib/helpers/cn";

type CalendarCellProps = {
  children?: ReactNode;
  className?: string;
} & AriaCalendarCellProps;

export function CalendarCell2(props: CalendarCellProps) {
  return (
    <AriaCalendarCell
      className={cn(
        "atom-keyboard-focus",
        "tw:my-0.5 tw:flex tw:size-8 tw:cursor-pointer tw:items-center tw:justify-center tw:rounded-full tw:text-base tw:text-text-secondary tw:outline-none",
        "tw:data-hovered:bg-fill-teal-quaternary tw:data-hovered:text-text-teal-primary",
        "tw:selected:bg-fill-teal-primary tw:selected:text-text-white!",
        "tw:outside-month:text-text-quaternary",
        "tw:data-disabled:cursor-not-allowed tw:data-disabled:text-text-quaternary",
        "tw:unavailable:text-text-quaternary tw:unavailable:line-through",
        "tw:data-today:ring-1 tw:data-today:ring-stroke-teal-primary",
      )}
      {...props}
    />
  );
}
